/* Apollo cart v3 - BUILD 2026-11-03 r44 (timeouts, no stuck ADDING, instant +/-, one request per burst, pack images drawn in, no reloads, stale-key check, no stale cart.js)
   One request per cart action; the drawer is always redrawn from Shopify's own section HTML,
   so what the shopper sees equals /cart.js. Replaces: add-1-then-correct (qb block), add-partner-
   then-replay (footer block), reload-on-merged-row (footer + qb blocks), href=/cart (cross-sell,
   bundle template). Loaded from the Vida Glow block as an asset. */
(function(){
  'use strict';
  var D = document;
  var SH_PID = 9587266683197, BT_PID = 10286493139261, SH_VID = 49189296931133, BT_VID = 51550923817277;

  /* ---- 1. coalesce GET /cart.js (other blocks poll it on every mutation tick) ---- */
  var CJ = null, CJ_AT = 0, GEN = 0, realFetch = window.fetch;
  /* GEN bumps on every cart write; a GET that was in flight across a write must not be cached */
  window.fetch = function(u, o){
    var url = typeof u === 'string' ? u : ((u && u.url) || '');
    var method = String((o && o.method) || (u && u.method) || 'GET').toUpperCase();
    /* r43: bump again when the write lands - a GET answered while it was still running can carry the old cart */
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      GEN++; CJ = null;
      return realFetch.apply(window, arguments).then(function(r){ GEN++; CJ = null; return r; }, function(e){ GEN++; CJ = null; throw e; });
    }
    if (method === 'GET' && /\/cart\.js(\?|$)/.test(url)) {
      if (CJ && Date.now() - CJ_AT < 8000) return Promise.resolve(CJ.clone());
      var g = GEN;
      /* r43: a write started or landed meanwhile - the answer may be the old cart (the drawer kept $90 for 4 bundles). Ask again. */
      return realFetch.apply(window, arguments).then(function(r){ if (g !== GEN) return window.fetch(u, o); if (r.ok) { CJ = r.clone(); CJ_AT = Date.now(); } return r; });
    }
    return realFetch.apply(window, arguments);
  };

  function money(c){ return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function onCartPage(){ return /^\/cart\/?$/.test(location.pathname); }
  function stop(e){ e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); }
  /* r44: nothing may hang the cart. A request that never answers (weak mobile signal) used to hold the queue, so the
     button stayed on ADDING and every later tap waited until the page was refreshed. */
  function timed(p, ms){ return new Promise(function(ok, no){ var t = setTimeout(function(){ no(new Error('timeout')); }, ms); p.then(function(v){ clearTimeout(t); ok(v); }, function(e){ clearTimeout(t); no(e); }); }); }
  function post(url, body, tries){
    tries = tries || 0;
    return timed(fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)}), 15000)
      .then(function(r){
        /* r44: Shopify answers 429 to fast tapping - wait and send again instead of failing */
        if (r.status === 429 && tries < 3) return new Promise(function(ok){ setTimeout(ok, 1200 * (tries + 1)); }).then(function(){ return post(url, body, tries + 1); });
        return r.json().then(function(j){ if (!r.ok) throw j; return j; });
      });
  }
  function cartJson(){ CJ = null; return timed(fetch('/cart.js'), 15000).then(function(r){ return r.json(); }); }

  function sectionNames(){
    if (onCartPage()) { var ci = D.querySelector('cart-items'); try { return ci.getSectionsToRender().map(function(s){ return s.section; }); } catch (e) { return []; } }
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  /* r40: pack images and one row per product are written into Shopify's HTML before it is drawn - no flash, no swap afterwards */
  var BU_PID = 10310411845949, CDNF = 'https://cdn.shopify.com/s/files/1/0887/0277/9709/files/';
  function tierImg(pid, q){ var f = pid === SH_PID ? (q >= 3 ? 'vg-qbj-3b.png' : q === 2 ? 'vg-qbj-2.png' : 'vg-qbj-1.png') : pid === BT_PID ? (q >= 3 ? 'vg-qbb-3g.png' : q === 2 ? 'vg-qbb-2g.png' : 'vg-qbb-1g.png') : 'vg-bundle-cut.png'; return CDNF + f + '?width=240'; }
  function prep(html, cart){
    if (!html || !cart || !cart.items) return html;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html'), rows = doc.querySelectorAll('.cart-item'), seen = {}, tot = {}, pidOf = {};
      cart.items.forEach(function(it){ tot[it.product_id] = (tot[it.product_id] || 0) + it.quantity; pidOf[it.variant_id] = it.product_id; });
      for (var i = 0; i < rows.length; i++){
        var r = rows[i], v = rowVariant(r); if (!v) continue;
        if (seen[v]) { r.parentNode.removeChild(r); continue; } seen[v] = 1;
        var g = groupOf(cart, v); if (g.length > 1) paint(r, cart, g); else if (g.length === 1) { r.dataset.vgVid = v; }
        var pid = pidOf[v], im = r.querySelector('.wt-cart__item__thumb img');
        if (pid && im){ var u = tierImg(pid, tot[pid] || 1); im.setAttribute('src', u); im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.setAttribute('loading', 'eager'); im.setAttribute('data-vgt', u); im.classList.add('vgu-cut'); }
      }
      return doc.documentElement.outerHTML;
    } catch (e) { return html; }
  }
  /* draw Shopify's section HTML into the page the same way the theme does */
  function render(resp, openIfClosed){
    if (!resp || !resp.sections) return;
    if (resp.items && typeof resp.total_price === 'number') window.__vgLastCart = resp; /* r33: full cart for instant cents */
    var empty = resp.item_count === 0;
    if (onCartPage()) {
      var ci = D.querySelector('cart-items'); if (!ci) return;
      ci.getSectionsToRender().forEach(function(s){
        var host = D.getElementById(s.id), html = resp.sections[s.section]; if (!host || !html) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
        var el = host.querySelector(s.selector) || host; if (src) el.innerHTML = src.innerHTML;
      });
      ci.classList.toggle('is-empty', empty); var cf = D.getElementById('main-cart-footer'); if (cf) cf.classList.toggle('is-empty', empty);
    } else {
      var d = D.querySelector('cart-drawer'); if (!d || typeof d.renderContents !== 'function') return;
      d.classList.toggle('is-empty', empty);
      var closed = !D.body.classList.contains('page-overlay-cart-on');
      var secs = {}; for (var k in resp.sections) secs[k] = k === 'cart-drawer' ? prep(resp.sections[k], resp.items ? resp : window.__vgLastCart) : resp.sections[k];
      d.renderContents({sections: secs}, !!openIfClosed && closed);
    }
    try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: resp}); } catch (e) {}
    D.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: resp}}));
  }

  /* ---- 2. one row per variant. Shopify splits a line when a discount covers only part of it ---- */
  function groupOf(cart, vid){ var g = []; for (var i = 0; i < cart.items.length; i++) if (String(cart.items[i].variant_id) === String(vid)) g.push(i); return g; }
  function paint(row, cart, g){
    if (!g.length) return;
    var qty = 0, fin = 0, orig = 0, keys = [];
    g.forEach(function(ix){ var it = cart.items[ix]; qty += it.quantity; fin += it.final_line_price; orig += it.original_line_price; keys.push(it.key); });
    row.dataset.vgKeys = keys.join(','); row.dataset.vgQty = qty; row.dataset.vgVid = cart.items[g[0]].variant_id;
    var pw = row.querySelector('.wt-cart__item__price-wrapper');
    if (pw) pw.innerHTML = (orig > fin ? '<s class="apxm__was">' + money(orig) + '</s>' : '') + '<b class="apxm__now">' + money(fin) + '</b>';
    else {
      var f = row.querySelectorAll('.cart-item__final-price, .price--end'); for (var i = 0; i < f.length; i++) f[i].textContent = money(fin);
      var o = row.querySelectorAll('.cart-item__old-price'); for (var j = 0; j < o.length; j++) o[j].textContent = money(orig);
    }
    var pill = row.querySelector('.wt-cart__item-discount');
    if (pill) { if (orig > fin) { pill.textContent = 'You save ' + money(orig - fin); pill.style.display = ''; } else pill.style.display = 'none'; }
    var qi = row.querySelector('input[name="updates[]"]'); if (qi) { qi.value = qty; qi.setAttribute('value', qty); }
    var n = row.querySelector('.apxm__n'); if (n) n.textContent = qty;
    row.style.opacity = '';
  }
  function merge(cart){
    if (!cart || !cart.items) return;
    var lists = D.querySelectorAll('cart-drawer-items, cart-items');
    for (var li = 0; li < lists.length; li++){
      var rows = lists[li].querySelectorAll('.cart-item'), i;
      for (i = 0; i < rows.length; i++) if (rows[i].dataset.vgVid) paint(rows[i], cart, groupOf(cart, rows[i].dataset.vgVid));
      if (rows.length !== cart.items.length) continue;
      var seen = {};
      for (i = 0; i < cart.items.length; i++){
        var v = cart.items[i].variant_id;
        if (seen[v] !== undefined) { if (rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]); continue; }
        seen[v] = i;
        var g = groupOf(cart, v); if (g.length > 1) paint(rows[i], cart, g);
      }
    }
  }
  function hasDupes(){
    var lists = D.querySelectorAll('cart-drawer-items, cart-items');
    for (var li = 0; li < lists.length; li++){
      var rows = lists[li].querySelectorAll('.cart-item'), seen = {};
      for (var i = 0; i < rows.length; i++){
        var a = rows[i].querySelector('a[href*="variant="]'); var m = a && /variant=(\d+)/.exec(a.getAttribute('href') || '');
        if (!m) continue; if (seen[m[1]]) return true; seen[m[1]] = 1;
      }
    }
    return false;
  }
  var mergeTimer = null;
  function later(c){}
  function scheduleMerge(){
    clearTimeout(mergeTimer);
    mergeTimer = setTimeout(function(){ if (!hasDupes()) return; cartJson().then(function(c){ merge(c); later(c); }); }, 150);
  }

  /* ---- 3. the actions ---- */
  /* r35: every cart action is queued and runs in order - a tap made while another update is in flight is no longer dropped */
  var Q = Promise.resolve(), pending = 0, busy = false;
  /* r44: each queued action gets at most 25 s, so one stuck action can never block the ones after it */
  function enqueue(fn){ pending++; busy = true; var run = function(){ return timed(Promise.resolve().then(fn), 25000); }; Q = Q.then(run, run).then(function(){ if (--pending === 0) busy = false; }, function(){ if (--pending === 0) busy = false; }); return Q; }
  function setBusy(btn, on){
    if (!btn) return;
    clearTimeout(btn.__vgT);
    if (on) { if (btn.dataset.vgTxt == null) btn.dataset.vgTxt = btn.innerHTML; btn.textContent = 'ADDING…'; btn.style.opacity = '.7'; btn.style.pointerEvents = 'none';
      /* r44: failsafe - the button always comes back */
      btn.__vgT = setTimeout(function(){ setBusy(btn, false); }, 20000); }
    else { if (btn.dataset.vgTxt != null) { btn.innerHTML = btn.dataset.vgTxt; delete btn.dataset.vgTxt; } btn.style.opacity = ''; btn.style.pointerEvents = ''; }
  }
  function addItems(items, btn){
    setBusy(btn, true);
    return enqueue(function(){
      return post('/cart/add.js', {items: items})
        .then(function(){ return redraw(true); })
        .catch(function(e){ console.error('vg-cart add', e); return redraw(true); })
        .then(function(){ setBusy(btn, false); }, function(){ setBusy(btn, false); });
    });
  }
  /* fresh cart + drawer HTML in parallel, drawn once */
  function redraw(open){
    var names = sectionNames().join(',');
    return Promise.all([cartJson(), timed(fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + '?sections=' + names), 15000).then(function(r){ return r.json(); })])
      .then(function(a){ var c = a[0]; c.sections = a[1]; window.__vgLastCart = c; render(c, open); merge(c); return c; })
      .catch(function(e){ console.error('vg-cart redraw', e); });
  }
  /* r40: + / - / remove change the number at once; taps within 350 ms go to Shopify as ONE update, never a reload */
  var WANT = {}, FT = null, INFL = false, DIRTY = false, MIXW = 0;
  function tap(row, nq){
    var v = rowVariant(row); if (!v) return;
    WANT[v] = Math.max(0, nq); row.dataset.vgQty = WANT[v];
    var qi = row.querySelector('input[name="updates[]"]'); if (qi) { qi.value = WANT[v]; qi.setAttribute('value', WANT[v]); }
    var n = row.querySelector('.apxm__n'); if (n) n.textContent = WANT[v];
    var pw = row.querySelector('.wt-cart__item__price-wrapper'); if (pw) pw.style.opacity = '.45';
    if (!WANT[v]) { row.style.transition = 'opacity .15s'; row.style.opacity = '0'; setTimeout(function(){ row.style.display = 'none'; }, 160); }
    clearTimeout(FT); FT = setTimeout(flush, 350);
  }
  function flush(){
    if (INFL) { DIRTY = true; return; }
    /* r42: custom.js is swapping the wholesale code, which re-keys the lines - send once it is done */
    /* r44: wait for it at most 5 s */
    if (window.__vgMixBusy && MIXW++ < 25) { clearTimeout(FT); FT = setTimeout(flush, 200); return; }
    MIXW = 0;
    var want = WANT; WANT = {}; if (!Object.keys(want).length) return;
    INFL = true;
    var base = window.__vgLastCart && window.__vgLastCart.items ? Promise.resolve(window.__vgLastCart) : cartJson();
    base.then(function(c){
      var updates = {}, any = false;
      for (var v in want){ var g = groupOf(c, v); if (!g.length) continue; any = true; g.forEach(function(ix, i){ updates[c.items[ix].key] = i === 0 ? want[v] : 0; }); }
      if (!any) return redraw(false);
      return post('/cart/update.js', {updates: updates, sections: sectionNames().join(','), sections_url: location.pathname})
        .then(function(resp){
          /* r42: the 4+4 / 5+5 code swap (custom.js) makes Shopify re-split the lines under new keys. An update sent with the
             old keys landed on the wrong line (one + gave three extra packs). Check the totals and resend once with the new keys. */
          var fix = {}, off = false;
          for (var v in want){ var g = groupOf(resp, v), q = 0; g.forEach(function(ix){ q += resp.items[ix].quantity; });
            if (q !== want[v] && g.length){ off = true; g.forEach(function(ix, i){ fix[resp.items[ix].key] = i === 0 ? want[v] : 0; }); } }
          if (!off) return resp;
          return post('/cart/update.js', {updates: fix, sections: sectionNames().join(','), sections_url: location.pathname});
        })
        .then(function(resp){ window.__vgLastCart = resp; render(resp, false); merge(resp); });
    }).catch(function(e){ console.error('vg-cart update', e); window.__vgLastCart = null; return redraw(false); })
      .then(function(){ INFL = false; if (DIRTY || Object.keys(WANT).length) { DIRTY = false; flush(); } });
  }
  function rowVariant(row){ var a = row && row.querySelector('a[href*="variant="]'); var m = a && /variant=(\d+)/.exec(a.getAttribute('href') || ''); return m ? m[1] : null; }
  function setLine(line, qty, row){
    if (row){ var pw = row.querySelector('.wt-cart__item__price-wrapper'); if (pw) pw.style.opacity = '.4'; if (!qty) row.style.opacity = '.35'; }
    var vid = rowVariant(row);
    return enqueue(function(){
      /* the line number can move when an earlier queued action removed a line: look it up again by product */
      var cur = vid && [].filter.call(D.querySelectorAll('cart-drawer .cart-item, cart-items .cart-item'), function(r){ return rowVariant(r) === vid && !r.dataset.vgKeys; })[0];
      var qi = cur && cur.querySelector('input[name="updates[]"]'), ln = qi ? parseInt(qi.getAttribute('data-index'), 10) : line;
      return post('/cart/change.js', {line: ln || line, quantity: qty, sections: sectionNames().join(','), sections_url: location.pathname})
        .then(function(cart){ render(cart, false); merge(cart); later(cart); })
        .catch(function(err){ console.error('vg-cart line', err); return redraw(false); });
    });
  }
  function setGroup(keys, qty, row){
    if (row) row.style.opacity = '.45';
    return enqueue(function(){
      var updates = {}; keys.forEach(function(k, i){ updates[k] = i === 0 ? qty : 0; });
      var sections = sectionNames().join(',');
      return post('/cart/update.js', {updates: updates, sections: sections, sections_url: location.pathname})
        .catch(function(){
          return keys.slice(1).reduce(function(p, k){ return p.then(function(){ return post('/cart/change.js', {id: k, quantity: 0}); }); }, Promise.resolve())
            .then(function(){ return post('/cart/change.js', {id: keys[0], quantity: qty, sections: sections, sections_url: location.pathname}); });
        })
        .then(function(cart){ render(cart, false); merge(cart); later(cart); })
        .catch(function(e){ console.error('vg-cart update', e); return redraw(false); });
    });
  }

  D.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) return;
    /* product page add to cart: theme button, theme sticky bar, our sticky bar */
    var atc = t.closest('.js-add-to-cart, .vg-sticky__btn');
    if (atc && /\/products\//.test(location.pathname)) {
      var idEl = D.querySelector('form[action*="/cart/add"] input[name="id"]') || D.querySelector('input[name="id"]');
      var vid = idEl && parseInt(idEl.value, 10); if (!vid) return;
      stop(e);
      var q = parseInt((D.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
      var items = [{id: vid, quantity: q}];
      var on = D.querySelector('.apxp__row.is-on'); var av = on && parseInt(on.getAttribute('data-vid'), 10);
      if (av) items.push({id: av, quantity: 1});
      var shown = atc.classList.contains('vg-sticky__btn') ? atc : (D.querySelector('.js-add-to-cart.product-form__submit') || atc);
      addItems(items, shown).then(function(){ if (on) on.classList.remove('is-on'); });
      return;
    }
    /* bundle page quantity selector */
    var bq = t.closest('.apx-qty-atc');
    if (bq) {
      var idEl2 = D.querySelector('form[action*="/cart/add"] input[name="id"]') || D.querySelector('input[name="id"]');
      var vid2 = idEl2 && parseInt(idEl2.value, 10); if (!vid2) return;
      stop(e);
      var onT = D.querySelector('[data-q].is-on'); var q2 = onT ? parseInt(onT.getAttribute('data-q'), 10) : 1;
      addItems([{id: vid2, quantity: q2 || 1}], bq);
      return;
    }
    /* drawer / cart page cross-sell */
    var xs = t.closest('.apxb__btn');
    if (xs) {
      stop(e);
      cartJson().then(function(c){
        var ids = c.items.map(function(i){ return i.product_id; }), hasS = ids.indexOf(SH_PID) > -1, hasB = ids.indexOf(BT_PID) > -1;
        var add = hasS && !hasB ? BT_VID : (hasB && !hasS ? SH_VID : null);
        if (add) return addItems([{id: add, quantity: 1}], xs);
      });
      return;
    }
    /* any cart row: bin or + / - */
    var row = t.closest('cart-drawer .cart-item, cart-items .cart-item');
    if (row) {
      var rm = t.closest('.wt-cart__item__remove, cart-remove-button');
      var btn = t.closest('.js-counter-increase, .js-counter-decrease, quantity-counter button, quantity-input button, .apxm__q button, .wt-cart__item__qty button, .cart-item__quantity button');
      if (!rm && !btn) return;
      stop(e);
      var qi0 = row.querySelector('input[name="updates[]"]'), cur = parseInt(row.dataset.vgQty || (qi0 && qi0.value), 10) || 0;
      if (rm) { tap(row, 0); return; }
      var dd = btn.getAttribute('data-d'), up = dd ? parseInt(dd, 10) > 0 : (btn.classList.contains('js-counter-increase') || /plus|increase|\+/i.test((btn.name || '') + ' ' + (btn.getAttribute('aria-label') || '') + ' ' + btn.textContent));
      tap(row, cur + (up ? 1 : -1));
    }
  }, true);
  D.addEventListener('change', function(e){
    var t = e.target; var row = t && t.closest && t.closest('cart-drawer .cart-item, cart-items .cart-item');
    if (!row || t.name !== 'updates[]') return;
    stop(e); tap(row, parseInt(t.value, 10) || 0);
  }, true);


  /* ---- 4. drawer chrome: "Continue shopping" closes the drawer instead of leaving the page ---- */
  function closeDrawer(){
    var d = D.querySelector('cart-drawer');
    if (d && d.hasAttribute('open') && typeof d.toggleDrawerClasses === 'function') d.toggleDrawerClasses();
    else { var x = D.querySelector('cart-drawer .wt-cart__drawer__close'); if (x) x.click(); }
  }
  D.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) return;
    var a = t.closest('a.wt-button--continue-shopping, a.wt-cart__back-link, cart-drawer a[href="/"], .apx-cartpage a[href="/"]');
    if (!a || !/continue shopping/i.test(a.textContent || '')) return;
    stop(e);
    if (onCartPage()) {
      var back = D.referrer && D.referrer.indexOf(location.host) > -1 && !/\/cart/.test(D.referrer);
      if (back) history.back(); else location.href = '/products/shilajit-resin';
    } else closeDrawer();
  }, true);

  /* r42: custom.js redraws after the wholesale code swap; a tap still waiting to be sent redraws on its own, and drawing
     the older cart first flashed the number back for half a second */
  window.vgCart = {add: addItems, redraw: function(open){ return INFL || Object.keys(WANT).length ? Promise.resolve() : redraw(open); }};

  /* theme-driven re-renders (a + on a plain line that then splits) */
  function watch(){
    var hosts = D.querySelectorAll('cart-drawer, cart-items, #main-cart-items');
    for (var i = 0; i < hosts.length; i++){ if (hosts[i].dataset.vgWatch) continue; hosts[i].dataset.vgWatch = '1'; new MutationObserver(scheduleMerge).observe(hosts[i], {childList: true, subtree: true}); }
    scheduleMerge();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', watch); else watch();
  setTimeout(watch, 1500);
})();
